export default __webpack_public_path__ + "static/media/tabIcon.77bf845e.png";